import {ModalContext, ModalDispatch} from "../context/ModalContext";
import React, {useContext} from "react";
const Modal = () => {
    const modalData = useContext(ModalContext);
    const modalDispatch = useContext(ModalDispatch);
    function closeModal() {
        modalDispatch({
            type : "hideModal"
        });
    }

    return (
        // <div className={`modal fade ${ modalData.showModal ? 'show' : ''}`} style={{display: modalData.showModal ? 'block' : 'none'}} onClick={closeModal} id="modal" role="dialog" aria-labelledby="modal">
            <div className={`modal-dialog ${modalData.showModal ? 'show' : ''}`} style={{
                display: modalData.showModal ? 'block' : 'none',
                position: 'absolute',
                top : '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1050000000,
                maxWidth: '500px',
                height: 'auto',
                backgroundColor: '#f18914',
                color: '#fff',
                fontSize: '16px',
                fontFamily: 'Montserrat, sans-serif',
                padding: '20px',
            }} role="document" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="modal-title h5" id="exampleModalLabel">{modalData.title}</div>
                        <button onClick={closeModal} type="button" className="btn btn--modal btn-close btn-close-white" data-dismiss="modal"
                                aria-label="Close"></button>
                    </div>
                    <div className="modal-body" dangerouslySetInnerHTML={{__html: modalData.content}}/>
                    <div className="mx-3">
                        {modalData.errorMsg && <div className="alert alert-danger">{modalData.errorMsg}</div>}
                        {modalData.successMsg && <div className="alert alert-success">{modalData.successMsg}</div>}
                    </div>
                </div>
            </div>
        // </div>
    );
};
export default Modal;